//import nav from '@/_nav'
import i18n from '@/plugins/i18n.js';
import defaultContainer from '@/containers/DefaultContainer';
import nav from '@/_nav';

//var initial_navItems = null;

/* */
export default {
   name: "refresh_nav",

   components: {
      defaultContainer,
      i18n,
   },

   data: () => {
      return {
      }
   },

   methods: {

      check_single_item(item,groups,platforms) {
         var intersect = false;
         let checked_profiles = [];
         let checked_platforms = [];
         console.log('check_single_item, name='+item.name+', groups='+JSON.stringify(groups))
         console.log('check_single_item, name='+item.name+', platforms='+JSON.stringify(platforms))

         if ( item.attributes ) {
            if ( 'profiles' in item.attributes ) {
               checked_profiles = item.attributes.profiles.split(' ');
               for ( var j=0;j<groups.length;j++) {
                  if ( checked_profiles.includes(groups[j]) ) {
                     intersect = true;
                     break;
                  }
                  console.log('check_single_item, intersect='+intersect+', group='+groups[j]+', profiles='+JSON.stringify(item.attributes.profiles))
               }
               item.attributes.hidden = !intersect;
               console.log('check_single_item, So, after profiles, item.name='+item.name+', hidden='+item.attributes.hidden);
            }
            if ( !intersect ) {
               if ( 'platforms' in item.attributes ) {
                  checked_platforms = item.attributes.platforms;
                  for ( var j=0;j<platforms.length;j++) {
                     if ( checked_platforms.includes(platforms[j]) ) {
                        intersect = true;
                        break;
                     }
                     console.log('check_single_item, intersect='+intersect+', platform='+platforms[j]+', profiles='+JSON.stringify(item.attributes.profiles))
                  }
                  item.attributes.hidden = !intersect;
                  console.log('check_single_item, So, after platforms, item.name='+item.name+', hidden='+item.attributes.hidden);
               }
            }

            // SideBarNav builds different templates, depending on item.children :
            // <template v-if="item.children">
            //   <SidebarNavDropdown>
            // or :
            // <template v-else>
            //   <SidebarNavItem>
            // "SidebarNavItem" is the only component to react to property "hidden"
            // So, if we alternate "children" property to "alt_children", and vice-versa
            if ( item.attributes.hidden==true && item.children ) {
               item['alt_children'] = item['children'];
               delete item['children'];
            }

            if ( 'lookChildren' in item.attributes && item.children ) {
               let sub_intersect = true;
               let count_false = item.children.length;
               for ( var j=0;j< item.children.length;j++ ) {
                  sub_intersect = this.check_single_item(item.children[j],groups,platforms);
               }
            }

         }
         return intersect;
      },

      refreshNav(sessionfields,platform_list) {
         let platforms = platform_list.split(',');
         let fields = JSON.parse(sessionfields);

         let groups = [];
         console.log('refreshNav(), fields='+JSON.stringify(fields));

         if ( fields.groups ) {
            for( var i=0;i<fields.groups.length;i++) {
               groups.push(fields.groups[i]);
            }
         }

         console.log('refreshNav(), platforms='+JSON.stringify(platforms));
         console.log('refreshNav(), groups='+JSON.stringify(groups));
 
         for( var i=0;i<nav.items.length;i++) {
            if ( nav.items[i].alt_children ) {
               nav.items[i]['children'] = nav.items[i]['alt_children'];
               delete nav.items[i]['alt_children'];
            }
         }
         console.log('refreshNav(), reinitialize nav.items='+JSON.stringify(nav.items));

         for( var i=0;i<nav.items.length;i++) {
            this.check_single_item(nav.items[i],groups,platforms);
         }

         console.log('refreshNav(), FINAL nav.items='+JSON.stringify(nav.items));
      }
   }
}
